import { IApplicationState } from '../../types/redux';
import { formatMaterials } from '../../utils/formatters';

export const selectBuilderDescription = (state: IApplicationState) => {
  const { description, constructionZone, materials, otherMaterials } = state.builderCard;

  return {
    description,
    constructionZone,
    materials: formatMaterials(materials, otherMaterials),
  };
};
